export default __webpack_public_path__ + "static/media/leader-template-image.6c298665.svg";